<template>
  <v-container class="content-wrapper" fluid>
    <!-- Toggle Buttons -->
    <v-row class="mt-2">
      <v-spacer></v-spacer>
      <v-col cols="2"></v-col>
      <v-col cols="12" sm="6" md="6" class="d-flex justify-center">
        <v-row no-gutters class="d-flex justify-center overflow-x-auto">
          <v-btn-toggle v-model="toggleTab" rounded mandatory class="d-flex">
            <v-btn
              v-if="!filtered"
              value="scientific"
              class="btn-selected"
              @click="toggleTab = 'scientific'"
            >
              Scientific Domain
            </v-btn>
            <v-btn
              v-if="!filtered"
              value="categories"
              class="btn-selected"
              @click="toggleTab = 'categories'"
            >
              Categories
            </v-btn>
            <v-btn
              v-if="!filtered"
              value="hosting-institution"
              class="btn-selected"
              @click="toggleTab = 'hosting-institution'"
            >
              Hosting Institution
            </v-btn>
            <v-btn
              v-show="!filtered"
              value="view-all"
              class="btn-selected"
              @click="toggleTab = 'view-all'"
            >
              View All
            </v-btn>
          </v-btn-toggle>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-col
        v-if="toggleTab === 'view-all'"
        cols="8"
        xl="8"
        lg="12"
        md="12"
        sm="12"
        class="d-flex justify-end"
      >
        <v-select
          v-model="sortBy"
          :items="itemsSortBy"
          dense
          style="max-width: 245px"
          outlined
          label="Sort By"
          rounded
          hide-details
          return-object
          @input="changeSortBy"
        >
        </v-select>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <!-- Filters -->
    <v-row class="mt-0">
      <v-spacer></v-spacer>
      <v-col cols="12" xl="2" lg="3" md="3" sm="12" xs="12">
        <v-row>
          <v-col cols="12">
            <v-card elevation="3" style="border-radius: 24px;">
              <v-card-text>
                <v-text-field
                  v-model.trim="service.text"
                  rounded
                  placeholder="Search"
                  outlined
                  dense
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                  clearable
                ></v-text-field>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Hosting Institution:</label>
                <v-autocomplete
                  v-model="service.institutions"
                  class="mt-2"
                  :items="institutions"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Hosting Institution'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Provider:</label>
                <v-autocomplete
                  v-model="service.providers"
                  class="mt-2"
                  :items="providers"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Provider'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Scientific Domain:</label>
                <v-autocomplete
                  v-model="service.domains"
                  class="mt-2"
                  :items="domains"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Scientific Domain'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Scientific SubDomain:</label>
                <v-autocomplete
                  v-model="service.subDomains"
                  class="mt-2"
                  :items="filteredSubDomains"
                  :item-value="'id'"
                  :item-text="'subDomain'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Scientific Subdomain'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Category:</label>
                <v-autocomplete
                  v-model="service.categories"
                  class="mt-2"
                  :items="categories"
                  :item-value="'id'"
                  :item-text="'subCategory'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Category'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Sub Category:</label>
                <v-autocomplete
                  v-model="service.subCategories"
                  class="mt-2"
                  :items="filteredSubCategories"
                  :item-value="'id'"
                  :item-text="'subCategory'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Subcategory'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Access Mode:</label>
                <v-autocomplete
                  v-model="service.accessModes"
                  class="mt-2"
                  :items="accessModes"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Access Mode'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Access Type:</label>
                <v-autocomplete
                  v-model="service.accessTypes"
                  class="mt-2"
                  :items="accessTypes"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Access Type'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Target Users:</label>
                <v-autocomplete
                  v-model="service.targetUsers"
                  class="mt-2"
                  :items="targetUsers"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Target Users'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Orderable:</label>
                <v-switch v-model="service.orderable" color="success" class="required"> </v-switch>
              </v-card-text>
              <v-card-actions class="mt-0 pt-0">
                <v-col cols="6" class="d-flex justify-end">
                  <v-btn
                    @click="clear"
                    outlined
                    block
                    depressed
                    large
                    text
                    class="primary200--text font-weight-bold"
                  >
                    Clear
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn
                    @click="triggerFilters"
                    :disabled="!isServicesValid"
                    block
                    depressed
                    rounded
                    large
                    color="primary200"
                    class="white--text font-weight-bold"
                    data-cy="submit"
                    >Done
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" xl="6" lg="9" md="9" sm="12" xs="12">
        <!-- Scientifics  -->
        <v-row class="mb-10 justify-start" v-if="toggleTab === 'scientific' && !filtered">
          <v-col
            cols="12"
            xl="3"
            lg="4"
            md="6"
            sm="6"
            xs="12"
            class="pa-3"
            v-for="scientific in scientifics"
            :key="'scientific-' + scientific.name"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                class="justify-center align-center"
                elevation="3"
                style="border-radius: 24px; height: 100%; "
                :class="{ 'on-hover': hover }"
                @click="filterDomain(scientific)"
              >
                <v-card-text>
                  <v-row class="text-center">
                    <v-col cols="12">
                      <v-avatar size="150px" class="rounded-xl">
                        <img v-bind:src="require('@/assets/svg/scientific/' + scientific.icon)" />
                      </v-avatar>
                    </v-col>
                    <v-col cols="12" class="mt-12 primary300--text">
                      <b>{{ scientific.name }}</b>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>

        <!--  Categories  -->
        <v-row class="mb-10 justify-start" v-if="toggleTab === 'categories' && !filtered">
          <v-col
            cols="12"
            xl="3"
            lg="4"
            md="6"
            sm="6"
            xs="12"
            class="pa-3"
            v-for="category in categoriesArray"
            :key="'category-' + category.name"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                class="justify-center align-center"
                elevation="3"
                style="border-radius: 24px; height: 100%; "
                :class="{ 'on-hover': hover }"
                @click="filterCategory(category)"
              >
                <v-card-text>
                  <v-row class="text-center">
                    <v-col cols="12">
                      <v-avatar size="150px" class="rounded-xl">
                        <img v-bind:src="require('@/assets/svg/categories/' + category.icon)" />
                      </v-avatar>
                    </v-col>
                    <v-col cols="12" class="mt-12 primary300--text">
                      <b>{{ category.name }}</b>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>

        <!-- Hosting Institutions -->
        <v-row class="mb-10 justify-start" v-if="toggleTab === 'hosting-institution' && !filtered">
          <v-col
            cols="12"
            xl="3"
            lg="4"
            md="6"
            sm="6"
            xs="12"
            class="pa-3"
            v-for="institution in institutions"
            :key="'institution-' + institution.id"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                class="justify-center align-center"
                elevation="3"
                style="border-radius: 24px; height: 100%; "
                :class="{ 'on-hover': hover }"
                @click="filterInstitution(institution)"
              >
                <v-card-text>
                  <v-row class="text-center">
                    <v-col cols="12">
                      <v-avatar size="150px" class="rounded-xl">
                        <v-img contain :src="institution.logoUrl">
                          <template v-slot:placeholder>
                            <v-img lazy-src="@/assets/img/blur.jpg"></v-img>
                          </template>
                        </v-img>
                      </v-avatar>
                    </v-col>
                    <v-col cols="12" class="mt-12 primary300--text">
                      <b>{{ institution.name }}</b>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>

        <!-- View All -->
        <v-row v-if="toggleTab === 'view-all' && !filtered">
          <MarketplaceServicesViewAll :sortParams="sortParams"></MarketplaceServicesViewAll>
        </v-row>
        <!-- Filtered View ALl -->
        <v-row v-if="filtered">
          <MarketplaceServicesFilteredViewAll
            :filteredParams="params"
            :sortParams="sortParams"
            @changeTab="toggleChangeTab"
          ></MarketplaceServicesFilteredViewAll>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</template>

<script>
import scientificsJs from '@/configs/scientifics.json';
import categoriesJs from '@/configs/categories.json';
import MarketplaceServicesViewAll from './MarketplaceServicesViewAll.vue';
import MarketplaceServicesFilteredViewAll from './MarketplaceServicesFilteredViewAll.vue';

export default {
  name: 'BrowseCatalogueServices',
  components: { MarketplaceServicesViewAll, MarketplaceServicesFilteredViewAll },
  data() {
    return {
      toggleTab: 'scientific',
      scientifics: scientificsJs,
      categoriesArray: categoriesJs,
      hostingInstitution: [],
      sortParams: '',
      filtered: false,
      params: {},
      service: {
        institutions: [],
        providers: [],
        domains: [],
        subDomains: [],
        categories: [],
        subCategories: [],
        accessModes: [],
        accessTypes: [],
        targetUsers: [],
        text: '',
        orderable: true,
      },
      institutions: [],
      providers: [],
      domains: [],
      allSubDomains: [],
      categories: [],
      allSubCategories: [],
      accessModes: [],
      accessTypes: [],
      targetUsers: [],
      sortBy: null,
      marketplaceServicesViewAll: '',
      itemsSortBy: [
        { text: 'Default', value: null },
        { text: 'Recently updated', value: 'updatedTimestamp', desc: true },
        { text: 'Recently added', value: 'createdTimestamp', desc: true },
        { text: 'A-Z', value: 'name', desc: false },
      ],
      queries: {},
      hasDefinedParams: {},
      initialToggleTab: '',
    };
  },
  mounted() {
    this.axios.get('/api/v1/hosting-institutions/all').then(res => {
      this.institutions = res.data;
    });
    this.axios.get('/api/v1/providers/light?size=-1').then(res => {
      this.providers = res.data.content;
    });
    this.axios.get('/api/v1/scientific-domains').then(res => {
      this.domains = res.data.content;
    });
    this.axios.get('/api/v1/scientific-subdomains').then(res => {
      this.allSubDomains = res.data.content;
    });
    this.axios.get('api/v1/resource-categories').then(res => {
      this.categories = res.data.content;
    });
    this.axios.get('/api/v1/resource-subcategories').then(res => {
      this.allSubCategories = res.data.content;
    });
    this.axios.get('/api/v1/access-modes').then(res => {
      this.accessModes = res.data.content;
    });
    this.axios.get('/api/v1/access-types').then(res => {
      this.accessTypes = res.data.content;
    });
    this.axios.get('/api/v1/targets').then(res => {
      this.targetUsers = res.data.content;
    });
    this.marketplaceServicesViewAll = this.$route.query.marketplaceServicesViewAll;
    if (this.marketplaceServicesViewAll) {
      this.toggleTab = 'view-all';
    }
  },
  created() {
    this.queries = this.$route.query;
    if (this.queries) {
      const paramsQueries = {
        domains: this.queries.domains,
        institutions: this.queries.institutions,
        subDomains: this.queries.subDomains,
        text: this.queries.text,
        accessModes: this.queries.accessModes,
        accessTypes: this.queries.accessTypes,
        categories: this.queries.categories,
        providers: this.queries.providers,
        subCategories: this.queries.subCategories,
        targets: this.queries.targets,
      };

      this.hasDefinedParams = Object.values(paramsQueries).some(value => value !== undefined);

      if (this.hasDefinedParams) {
        console.log('params', paramsQueries);
        this.filtered = true;
        this.params = paramsQueries;
      }
    }
  },
  watch: {
    toggleTab(newValue) {
      if (
        newValue === 'hosting-institution' ||
        newValue === 'scientific' ||
        newValue === 'categories'
      ) {
        this.sortBy = '';
        this.sortParams = this.sortBy;
      }
    },
    '$route.query': {
      immediate: true,
      deep: true,
      handler(query) {
        if (query.filters === 'true' && query.marketplaceServicesViewAll) {
          const { ...filterParams } = query;
          if (filterParams.orderable === 'true') filterParams.orderable = true;
          if (filterParams.orderable === 'false') filterParams.orderable = false;
          if (Object.keys(filterParams).length > 0) {
            this.filtered = true;
            this.params = filterParams;
            if (filterParams.text) {
              this.service.text = filterParams.text;
            }
            if (filterParams.orderable !== undefined) {
              this.service.orderable = filterParams.orderable;
            }
            if (filterParams.institutions) {
              this.service.institutions = filterParams.institutions.split(',').map(Number);
            }
            if (filterParams.providers) {
              this.service.providers = filterParams.providers.split(',').map(Number);
            }
            if (filterParams.domains) {
              const domainArray = filterParams.domains.split(/,(?=[A-Z])/);
              this.service.domains = domainArray.map(d => d.trim());
            }
            if (filterParams.subDomains) {
              this.service.subDomains = filterParams.subDomains.split(',').map(Number);
            }
            if (filterParams.categories) {
              const domainCategory = filterParams.categories.split(/,(?=[A-Z])/);
              this.service.categories = domainCategory.map(d => d.trim());
            }
            if (filterParams.subCategories) {
              this.service.subCategories = filterParams.subCategories.split(',').map(Number);
            }
            if (filterParams.accessModes) {
              this.service.accessModes = filterParams.accessModes.split(',').map(Number);
            }
            if (filterParams.accessTypes) {
              this.service.accessTypes = filterParams.accessTypes.split(',').map(Number);
            }
            if (filterParams.targets) {
              this.service.targetUsers = filterParams.targets.split(',').map(Number);
            }
          }
        }
      },
    },
  },
  computed: {
    isServicesValid() {
      const servicesFields = [
        ...this.service.institutions,
        ...this.service.providers,
        ...this.service.domains,
        ...this.service.subDomains,
        ...this.service.categories,
        ...this.service.subCategories,
        ...this.service.accessModes,
        ...this.service.accessTypes,
        ...this.service.targetUsers,
        this.service.text,
      ];

      return servicesFields.some(field => field) || this.service.orderable !== undefined;
    },
    filteredSubDomains() {
      if (!this.service.domains.length) {
        return this.allSubDomains;
      }

      return this.allSubDomains.filter(serviceDomains =>
        this.service.domains.includes(serviceDomains.domain),
      );
    },
    filteredSubCategories() {
      if (!this.service.categories.length) {
        return this.allSubCategories;
      }

      return this.allSubCategories.filter(serviceCategories =>
        this.service.categories.includes(serviceCategories.category),
      );
    },
  },
  methods: {
    toggleChangeTab() {
      this.clear();
    },
    clear() {
      this.service.institutions = [];
      this.service.providers = [];
      this.service.domains = [];
      this.service.subDomains = [];
      this.service.categories = [];
      this.service.subCategories = [];
      this.service.accessModes = [];
      this.service.accessTypes = [];
      this.service.targetUsers = [];
      this.service.text = '';
      this.service.orderable = true;
      this.filtered = false;
      if (this.initialToggleTab) {
        this.toggleTab = this.initialToggleTab;
      }
      if (this.$store.getters.roles && this.hasDefinedParams) {
        this.$router.push({
          path: '/marketplace/services',
          query: {
            selectedCatalogue: 'Browse the Catalogue of Services',
            marketplaceServicesViewAll: true,
          },
        });
      } else if (!this.$store.getters.roles && this.hasDefinedParams) {
        this.$router.push({
          path: '/public-catalogue-marketplace/services',
          query: {
            selectedCatalogue: 'Browse the Catalogue of Services',
            marketplaceServicesViewAll: true,
          },
        });
      }
    },
    triggerFilters() {
      const institutionIds = this.service.institutions.map(institution => institution);
      const providersIds = this.service.providers.map(provider => provider);
      const domains = this.service.domains.map(domain => domain);
      const subDomains = this.service.subDomains.map(subDomain => subDomain);
      const categories = this.service.categories.map(category => category);
      const subCategories = this.service.subCategories.map(subCategory => subCategory);
      const accessModes = this.service.accessModes.map(accessMode => accessMode);
      const accessTypes = this.service.accessTypes.map(accessType => accessType);
      const targetUsers = this.service.targetUsers.map(targetUser => targetUser);

      const institutionParams = institutionIds.join(',');
      const providerParams = providersIds.join(',');
      const domainParams = domains.join(',');
      const subDomainsParams = subDomains.join(',');
      const categoriesParams = categories.join(',');
      const subCategoriesParams = subCategories.join(',');
      const accessModesParams = accessModes.join(',');
      const accessTypesParams = accessTypes.join(',');
      const targetUsersParams = targetUsers.join(',');

      const params = {
        institutions: institutionParams,
        providers: providerParams,
        domains: domainParams,
        subDomains: subDomainsParams,
        categories: categoriesParams,
        subCategories: subCategoriesParams,
        accessModes: accessModesParams,
        accessTypes: accessTypesParams,
        targets: targetUsersParams,
        text: this.service.text,
        orderable: this.service.orderable,
      };

      this.deleteEmptyProperties(params);
      this.filtered = true;
      this.params = params;
      this.initialToggleTab = this.toggleTab;
    },
    deleteEmptyProperties(obj) {
      if (!obj || typeof obj !== 'object') {
        return;
      }

      if (Array.isArray(obj)) {
        obj.forEach((item, index) => {
          if (item === null || item === undefined || item === '') {
            obj.splice(index, 1);
          } else if (typeof item === 'object') {
            this.deleteEmptyProperties(item);
            if (Object.keys(item).length === 0) {
              obj.splice(index, 1);
            }
          }
        });
      } else {
        for (const key in obj) {
          if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
            delete obj[key];
          } else if (Array.isArray(obj[key])) {
            this.deleteEmptyProperties(obj[key]);
            if (obj[key].length === 0) {
              delete obj[key];
            }
          } else if (typeof obj[key] === 'object') {
            this.deleteEmptyProperties(obj[key]);
            if (Object.keys(obj[key]).length === 0) {
              delete obj[key];
            }
          }
        }
      }
    },
    filterInstitution(institution) {
      const institutionId = institution.id;
      const params = {
        institutions: institutionId,
      };
      this.filtered = true;
      this.params = params;
      this.initialToggleTab = this.toggleTab;
    },
    filterDomain(scientific) {
      const urlParams = new URLSearchParams(scientific.url.split('?')[1]);
      const domainUrl = urlParams.get('domains');

      const params = {
        domains: domainUrl,
      };
      this.filtered = true;
      this.params = params;
      this.initialToggleTab = this.toggleTab;
    },
    filterCategory(category) {
      const urlParams = new URLSearchParams(category.url.split('?')[1]);
      const categoryName = urlParams.get('superCategories');

      const params = {
        superCategories: categoryName,
      };
      this.filtered = true;
      this.params = params;
      this.initialToggleTab = this.toggleTab;
    },

    changeSortBy(selected) {
      let params = '';

      if (selected && selected.value) {
        const sortField = selected.value;
        const sortOrder = selected.desc ? 'desc' : 'asc';
        params = `sort=${sortField}+${sortOrder}`;
        this.sortParams = params;
      } else {
        this.sortParams = '';
      }
    },
  },
};
</script>

<style scoped>
.btn-selected {
  font-weight: bold;
}
</style>
